import {
  AUTHENTICATE_USER_REQUESTED,
  AUTHENTICATE_USER_SUCCEEDED,
  AUTHENTICATE_USER_ERRORED,
  FETCH_USER_REQUESTED,
  FETCH_USER_SUCCEEDED,
  FETCH_USER_ERRORED,
} from 'config/types/action';
import { user as defaultState } from 'config/defaultState';

export default (state = defaultState, { type, payload }) => {
  switch (type) {
    case AUTHENTICATE_USER_REQUESTED:
      return {
        ...state,
        authentication: {
          isLoading: true,
        },
      };
    case AUTHENTICATE_USER_SUCCEEDED:
      return {
        ...state,
        authentication: {
          isLoading: false,
          remoteData: payload,
        },
      };
    case AUTHENTICATE_USER_ERRORED:
      return {
        ...state,
        authentication: {
          isLoading: false,
          error: payload,
        },
      };
    case FETCH_USER_REQUESTED:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_USER_SUCCEEDED:
      return {
        ...state,
        error: undefined,
        isLoading: false,
        remoteData: payload,
      };
    case FETCH_USER_ERRORED:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    default:
      return state;
  }
};
